import React from 'react';

export default ({}) => {
    return (
        <div className="pdp-features">
            <h2>1. When is my order arriving?</h2>
            <span>
                When stock is available, your order will be shipped and you will receive a shipping confirmation email.
                After that, the delivery period is stated on the shipping method information on checkout and order
                confirmation.
            </span>
            <h2>2. Can I track a pre-order's shipping status?</h2>
            <span>
                Your order can be tracked like any other order in the "My orders" section of your HP.com account or with
                your order number for guest purchases. You will also receive a shipping notification when the product
                has shipped."
            </span>
            <h2>3. When will I be charged?</h2>
            <span>
                We will charge the total amount of your pre-order when it is shipped. Prior to this payment, we will
                only create a pre-authorization transaction on your credit or debit card for security purposes. This
                action will not impact your credit limits.
            </span>
            <h2>4. Can I cancel a pre-order?</h2>
            <span>
                Pre-orders have the same cancellation policies as a regular order on our store. Once placed, you can not
                cancel or modify the order. For more information, read our cancel and changes polices here.
            </span>
            <h2>5. Can I purchase a pre-order and a regular product together?</h2>
            <span>
                You can't create mix orders with pre-order and regular products. When you click "Pre-order now", you
                will be taken directly into the checkout. Your cart items will remain there after you complete the
                pre-order process. If you do not complete the pre-order purchase, your cart items will still be there
                but your pre-order product won't be included.
            </span>
        </div>
    );
};
